export const countries = [
    {
        "label": "Afghanistan",
        "country_code": "+93",
        "code": "AF"
    },
    {
        "label": "Aland Islands",
        "country_code": "+358",
        "code": "AX"
    },
    {
        "label": "Albania",
        "country_code": "+355",
        "code": "AL"
    },
    {
        "label": "Algeria",
        "country_code": "+213",
        "code": "DZ"
    },
    {
        "label": "AmericanSamoa",
        "country_code": "+1684",
        "code": "AS"
    },
    {
        "label": "Andorra",
        "country_code": "+376",
        "code": "AD"
    },
    {
        "label": "Angola",
        "country_code": "+244",
        "code": "AO"
    },
    {
        "label": "Anguilla",
        "country_code": "+1264",
        "code": "AI"
    },
    {
        "label": "Antarctica",
        "country_code": "+672",
        "code": "AQ"
    },
    {
        "label": "Antigua and Barbuda",
        "country_code": "+1268",
        "code": "AG"
    },
    {
        "label": "Argentina",
        "country_code": "+54",
        "code": "AR"
    },
    {
        "label": "Armenia",
        "country_code": "+374",
        "code": "AM"
    },
    {
        "label": "Aruba",
        "country_code": "+297",
        "code": "AW"
    },
    {
        "label": "Australia",
        "country_code": "+61",
        "code": "AU"
    },
    {
        "label": "Austria",
        "country_code": "+43",
        "code": "AT"
    },
    {
        "label": "Azerbaijan",
        "country_code": "+994",
        "code": "AZ"
    },
    {
        "label": "Bahamas",
        "country_code": "+1242",
        "code": "BS"
    },
    {
        "label": "Bahrain",
        "country_code": "+973",
        "code": "BH"
    },
    {
        "label": "Bangladesh",
        "country_code": "+880",
        "code": "BD"
    },
    {
        "label": "Barbados",
        "country_code": "+1246",
        "code": "BB"
    },
    {
        "label": "Belarus",
        "country_code": "+375",
        "code": "BY"
    },
    {
        "label": "Belgium",
        "country_code": "+32",
        "code": "BE"
    },
    {
        "label": "Belize",
        "country_code": "+501",
        "code": "BZ"
    },
    {
        "label": "Benin",
        "country_code": "+229",
        "code": "BJ"
    },
    {
        "label": "Bermuda",
        "country_code": "+1441",
        "code": "BM"
    },
    {
        "label": "Bhutan",
        "country_code": "+975",
        "code": "BT"
    },
    {
        "label": "Bolivia, Plurinational State of",
        "country_code": "+591",
        "code": "BO"
    },
    {
        "label": "Bosnia and Herzegovina",
        "country_code": "+387",
        "code": "BA"
    },
    {
        "label": "Botswana",
        "country_code": "+267",
        "code": "BW"
    },
    {
        "label": "Brazil",
        "country_code": "+55",
        "code": "BR"
    },
    {
        "label": "British Indian Ocean Territory",
        "country_code": "+246",
        "code": "IO"
    },
    {
        "label": "Brunei Darussalam",
        "country_code": "+673",
        "code": "BN"
    },
    {
        "label": "Bulgaria",
        "country_code": "+359",
        "code": "BG"
    },
    {
        "label": "Burkina Faso",
        "country_code": "+226",
        "code": "BF"
    },
    {
        "label": "Burundi",
        "country_code": "+257",
        "code": "BI"
    },
    {
        "label": "Cambodia",
        "country_code": "+855",
        "code": "KH"
    },
    {
        "label": "Cameroon",
        "country_code": "+237",
        "code": "CM"
    },
    {
        "label": "Canada",
        "country_code": "+1",
        "code": "CA"
    },
    {
        "label": "Cape Verde",
        "country_code": "+238",
        "code": "CV"
    },
    {
        "label": "Cayman Islands",
        "country_code": "+ 345",
        "code": "KY"
    },
    {
        "label": "Central African Republic",
        "country_code": "+236",
        "code": "CF"
    },
    {
        "label": "Chad",
        "country_code": "+235",
        "code": "TD"
    },
    {
        "label": "Chile",
        "country_code": "+56",
        "code": "CL"
    },
    {
        "label": "China",
        "country_code": "+86",
        "code": "CN"
    },
    {
        "label": "Christmas Island",
        "country_code": "+61",
        "code": "CX"
    },
    {
        "label": "Cocos (Keeling) Islands",
        "country_code": "+61",
        "code": "CC"
    },
    {
        "label": "Colombia",
        "country_code": "+57",
        "code": "CO"
    },
    {
        "label": "Comoros",
        "country_code": "+269",
        "code": "KM"
    },
    {
        "label": "Congo",
        "country_code": "+242",
        "code": "CG"
    },
    {
        "label": "Congo, The Democratic Republic of the Congo",
        "country_code": "+243",
        "code": "CD"
    },
    {
        "label": "Cook Islands",
        "country_code": "+682",
        "code": "CK"
    },
    {
        "label": "Costa Rica",
        "country_code": "+506",
        "code": "CR"
    },
    {
        "label": "Cote d'Ivoire",
        "country_code": "+225",
        "code": "CI"
    },
    {
        "label": "Croatia",
        "country_code": "+385",
        "code": "HR"
    },
    {
        "label": "Cuba",
        "country_code": "+53",
        "code": "CU"
    },
    {
        "label": "Cyprus",
        "country_code": "+357",
        "code": "CY"
    },
    {
        "label": "Czech Republic",
        "country_code": "+420",
        "code": "CZ"
    },
    {
        "label": "Denmark",
        "country_code": "+45",
        "code": "DK"
    },
    {
        "label": "Djibouti",
        "country_code": "+253",
        "code": "DJ"
    },
    {
        "label": "Dominica",
        "country_code": "+1767",
        "code": "DM"
    },
    {
        "label": "Dominican Republic",
        "country_code": "+1849",
        "code": "DO"
    },
    {
        "label": "Ecuador",
        "country_code": "+593",
        "code": "EC"
    },
    {
        "label": "Egypt",
        "country_code": "+20",
        "code": "EG"
    },
    {
        "label": "El Salvador",
        "country_code": "+503",
        "code": "SV"
    },
    {
        "label": "Equatorial Guinea",
        "country_code": "+240",
        "code": "GQ"
    },
    {
        "label": "Eritrea",
        "country_code": "+291",
        "code": "ER"
    },
    {
        "label": "Estonia",
        "country_code": "+372",
        "code": "EE"
    },
    {
        "label": "Ethiopia",
        "country_code": "+251",
        "code": "ET"
    },
    {
        "label": "Falkland Islands (Malvinas)",
        "country_code": "+500",
        "code": "FK"
    },
    {
        "label": "Faroe Islands",
        "country_code": "+298",
        "code": "FO"
    },
    {
        "label": "Fiji",
        "country_code": "+679",
        "code": "FJ"
    },
    {
        "label": "Finland",
        "country_code": "+358",
        "code": "FI"
    },
    {
        "label": "France",
        "country_code": "+33",
        "code": "FR"
    },
    {
        "label": "French Guiana",
        "country_code": "+594",
        "code": "GF"
    },
    {
        "label": "French Polynesia",
        "country_code": "+689",
        "code": "PF"
    },
    {
        "label": "Gabon",
        "country_code": "+241",
        "code": "GA"
    },
    {
        "label": "Gambia",
        "country_code": "+220",
        "code": "GM"
    },
    {
        "label": "Georgia",
        "country_code": "+995",
        "code": "GE"
    },
    {
        "label": "Germany",
        "country_code": "+49",
        "code": "DE"
    },
    {
        "label": "Ghana",
        "country_code": "+233",
        "code": "GH"
    },
    {
        "label": "Gibraltar",
        "country_code": "+350",
        "code": "GI"
    },
    {
        "label": "Greece",
        "country_code": "+30",
        "code": "GR"
    },
    {
        "label": "Greenland",
        "country_code": "+299",
        "code": "GL"
    },
    {
        "label": "Grenada",
        "country_code": "+1473",
        "code": "GD"
    },
    {
        "label": "Guadeloupe",
        "country_code": "+590",
        "code": "GP"
    },
    {
        "label": "Guam",
        "country_code": "+1671",
        "code": "GU"
    },
    {
        "label": "Guatemala",
        "country_code": "+502",
        "code": "GT"
    },
    {
        "label": "Guernsey",
        "country_code": "+44",
        "code": "GG"
    },
    {
        "label": "Guinea",
        "country_code": "+224",
        "code": "GN"
    },
    {
        "label": "Guinea-Bissau",
        "country_code": "+245",
        "code": "GW"
    },
    {
        "label": "Guyana",
        "country_code": "+595",
        "code": "GY"
    },
    {
        "label": "Haiti",
        "country_code": "+509",
        "code": "HT"
    },
    {
        "label": "Holy See (Vatican City State)",
        "country_code": "+379",
        "code": "VA"
    },
    {
        "label": "Honduras",
        "country_code": "+504",
        "code": "HN"
    },
    {
        "label": "Hong Kong",
        "country_code": "+852",
        "code": "HK"
    },
    {
        "label": "Hungary",
        "country_code": "+36",
        "code": "HU"
    },
    {
        "label": "Iceland",
        "country_code": "+354",
        "code": "IS"
    },
    {
        "label": "India",
        "country_code": "+91",
        "code": "IN"
    },
    {
        "label": "Indonesia",
        "country_code": "+62",
        "code": "ID"
    },
    {
        "label": "Iran, Islamic Republic of Persian Gulf",
        "country_code": "+98",
        "code": "IR"
    },
    {
        "label": "Iraq",
        "country_code": "+964",
        "code": "IQ"
    },
    {
        "label": "Ireland",
        "country_code": "+353",
        "code": "IE"
    },
    {
        "label": "Isle of Man",
        "country_code": "+44",
        "code": "IM"
    },
    {
        "label": "Israel",
        "country_code": "+972",
        "code": "IL"
    },
    {
        "label": "Italy",
        "country_code": "+39",
        "code": "IT"
    },
    {
        "label": "Jamaica",
        "country_code": "+1876",
        "code": "JM"
    },
    {
        "label": "Japan",
        "country_code": "+81",
        "code": "JP"
    },
    {
        "label": "Jersey",
        "country_code": "+44",
        "code": "JE"
    },
    {
        "label": "Jordan",
        "country_code": "+962",
        "code": "JO"
    },
    {
        "label": "Kazakhstan",
        "country_code": "+77",
        "code": "KZ"
    },
    {
        "label": "Kenya",
        "country_code": "+254",
        "code": "KE"
    },
    {
        "label": "Kiribati",
        "country_code": "+686",
        "code": "KI"
    },
    {
        "label": "Korea, Democratic People's Republic of Korea",
        "country_code": "+850",
        "code": "KP"
    },
    {
        "label": "Korea, Republic of South Korea",
        "country_code": "+82",
        "code": "KR"
    },
    {
        "label": "Kuwait",
        "country_code": "+965",
        "code": "KW"
    },
    {
        "label": "Kyrgyzstan",
        "country_code": "+996",
        "code": "KG"
    },
    {
        "label": "Laos",
        "country_code": "+856",
        "code": "LA"
    },
    {
        "label": "Latvia",
        "country_code": "+371",
        "code": "LV"
    },
    {
        "label": "Lebanon",
        "country_code": "+961",
        "code": "LB"
    },
    {
        "label": "Lesotho",
        "country_code": "+266",
        "code": "LS"
    },
    {
        "label": "Liberia",
        "country_code": "+231",
        "code": "LR"
    },
    {
        "label": "Libyan Arab Jamahiriya",
        "country_code": "+218",
        "code": "LY"
    },
    {
        "label": "Liechtenstein",
        "country_code": "+423",
        "code": "LI"
    },
    {
        "label": "Lithuania",
        "country_code": "+370",
        "code": "LT"
    },
    {
        "label": "Luxembourg",
        "country_code": "+352",
        "code": "LU"
    },
    {
        "label": "Macao",
        "country_code": "+853",
        "code": "MO"
    },
    {
        "label": "Macedonia",
        "country_code": "+389",
        "code": "MK"
    },
    {
        "label": "Madagascar",
        "country_code": "+261",
        "code": "MG"
    },
    {
        "label": "Malawi",
        "country_code": "+265",
        "code": "MW"
    },
    {
        "label": "Malaysia",
        "country_code": "+60",
        "code": "MY"
    },
    {
        "label": "Maldives",
        "country_code": "+960",
        "code": "MV"
    },
    {
        "label": "Mali",
        "country_code": "+223",
        "code": "ML"
    },
    {
        "label": "Malta",
        "country_code": "+356",
        "code": "MT"
    },
    {
        "label": "Marshall Islands",
        "country_code": "+692",
        "code": "MH"
    },
    {
        "label": "Martinique",
        "country_code": "+596",
        "code": "MQ"
    },
    {
        "label": "Mauritania",
        "country_code": "+222",
        "code": "MR"
    },
    {
        "label": "Mauritius",
        "country_code": "+230",
        "code": "MU"
    },
    {
        "label": "Mayotte",
        "country_code": "+262",
        "code": "YT"
    },
    {
        "label": "Mexico",
        "country_code": "+52",
        "code": "MX"
    },
    {
        "label": "Micronesia, Federated States of Micronesia",
        "country_code": "+691",
        "code": "FM"
    },
    {
        "label": "Moldova",
        "country_code": "+373",
        "code": "MD"
    },
    {
        "label": "Monaco",
        "country_code": "+377",
        "code": "MC"
    },
    {
        "label": "Mongolia",
        "country_code": "+976",
        "code": "MN"
    },
    {
        "label": "Montenegro",
        "country_code": "+382",
        "code": "ME"
    },
    {
        "label": "Montserrat",
        "country_code": "+1664",
        "code": "MS"
    },
    {
        "label": "Morocco",
        "country_code": "+212",
        "code": "MA"
    },
    {
        "label": "Mozambique",
        "country_code": "+258",
        "code": "MZ"
    },
    {
        "label": "Myanmar",
        "country_code": "+95",
        "code": "MM"
    },
    {
        "label": "Namibia",
        "country_code": "+264",
        "code": "NA"
    },
    {
        "label": "Nauru",
        "country_code": "+674",
        "code": "NR"
    },
    {
        "label": "Nepal",
        "country_code": "+977",
        "code": "NP"
    },
    {
        "label": "Netherlands",
        "country_code": "+31",
        "code": "NL"
    },
    {
        "label": "Netherlands Antilles",
        "country_code": "+599",
        "code": "AN"
    },
    {
        "label": "New Caledonia",
        "country_code": "+687",
        "code": "NC"
    },
    {
        "label": "New Zealand",
        "country_code": "+64",
        "code": "NZ"
    },
    {
        "label": "Nicaragua",
        "country_code": "+505",
        "code": "NI"
    },
    {
        "label": "Niger",
        "country_code": "+227",
        "code": "NE"
    },
    {
        "label": "Nigeria",
        "country_code": "+234",
        "code": "NG"
    },
    {
        "label": "Niue",
        "country_code": "+683",
        "code": "NU"
    },
    {
        "label": "Norfolk Island",
        "country_code": "+672",
        "code": "NF"
    },
    {
        "label": "Norway",
        "country_code": "+47",
        "code": "NO"
    },
    {
        "label": "Oman",
        "country_code": "+968",
        "code": "OM"
    },
    {
        "label": "Pakistan",
        "country_code": "+92",
        "code": "PK"
    },
    {
        "label": "Palau",
        "country_code": "+680",
        "code": "PW"
    },
    {
        "label": "Palestinian Territory, Occupied",
        "country_code": "+970",
        "code": "PS"
    },
    {
        "label": "Panama",
        "country_code": "+507",
        "code": "PA"
    },
    {
        "label": "Papua New Guinea",
        "country_code": "+675",
        "code": "PG"
    },
    {
        "label": "Paraguay",
        "country_code": "+595",
        "code": "PY"
    },
    {
        "label": "Peru",
        "country_code": "+51",
        "code": "PE"
    },
    {
        "label": "Philippines",
        "country_code": "+63",
        "code": "PH"
    },
    {
        "label": "Pitcairn",
        "country_code": "+870",
        "code": "PN"
    },
    {
        "label": "Poland",
        "country_code": "+48",
        "code": "PL"
    },
    {
        "label": "Portugal",
        "country_code": "+351",
        "code": "PT"
    },
    {
        "label": "Puerto Rico",
        "country_code": "+1",
        "code": "PR"
    },
    {
        "label": "Qatar",
        "country_code": "+974",
        "code": "QA"
    },
    {
        "label": "Reunion",
        "country_code": "+262",
        "code": "RE"
    },
    {
        "label": "Romania",
        "country_code": "+40",
        "code": "RO"
    },
    {
        "label": "Russian Federation",
        "country_code": "+7",
        "code": "RU"
    },
    {
        "label": "Rwanda",
        "country_code": "+250",
        "code": "RW"
    },
    {
        "label": "Saint Barthelemy",
        "country_code": "+590",
        "code": "BL"
    },
    {
        "label": "Saint Helena, Ascension and Tristan da Cunha",
        "country_code": "+290",
        "code": "SH"
    },
    {
        "label": "Saint Kitts and Nevis",
        "country_code": "+1869",
        "code": "KN"
    },
    {
        "label": "Saint Lucia",
        "country_code": "+1758",
        "code": "LC"
    },
    {
        "label": "Saint Martin (French part)",
        "country_code": "+590",
        "code": "MF"
    },
    {
        "label": "Saint Pierre and Miquelon",
        "country_code": "+508",
        "code": "PM"
    },
    {
        "label": "Saint Vincent and the Grenadines",
        "country_code": "+1784",
        "code": "VC"
    },
    {
        "label": "Samoa",
        "country_code": "+685",
        "code": "WS"
    },
    {
        "label": "San Marino",
        "country_code": "+378",
        "code": "SM"
    },
    {
        "label": "Sao Tome and Principe",
        "country_code": "+239",
        "code": "ST"
    },
    {
        "label": "Saudi Arabia",
        "country_code": "+966",
        "code": "SA"
    },
    {
        "label": "Senegal",
        "country_code": "+221",
        "code": "SN"
    },
    {
        "label": "Serbia",
        "country_code": "+381",
        "code": "RS"
    },
    {
        "label": "Seychelles",
        "country_code": "+248",
        "code": "SC"
    },
    {
        "label": "Sierra Leone",
        "country_code": "+232",
        "code": "SL"
    },
    {
        "label": "Singapore",
        "country_code": "+65",
        "code": "SG"
    },
    {
        "label": "Slovakia",
        "country_code": "+421",
        "code": "SK"
    },
    {
        "label": "Slovenia",
        "country_code": "+386",
        "code": "SI"
    },
    {
        "label": "Solomon Islands",
        "country_code": "+677",
        "code": "SB"
    },
    {
        "label": "Somalia",
        "country_code": "+252",
        "code": "SO"
    },
    {
        "label": "South Africa",
        "country_code": "+27",
        "code": "ZA"
    },
    {
        "label": "South Georgia and the South Sandwich Islands",
        "country_code": "+500",
        "code": "GS"
    },
    {
        "label": "Spain",
        "country_code": "+34",
        "code": "ES"
    },
    {
        "label": "Sri Lanka",
        "country_code": "+94",
        "code": "LK"
    },
    {
        "label": "Sudan",
        "country_code": "+249",
        "code": "SD"
    },
    {
        "label": "Suriname",
        "country_code": "+597",
        "code": "SR"
    },
    {
        "label": "Svalbard and Jan Mayen",
        "country_code": "+47",
        "code": "SJ"
    },
    {
        "label": "Swaziland",
        "country_code": "+268",
        "code": "SZ"
    },
    {
        "label": "Sweden",
        "country_code": "+46",
        "code": "SE"
    },
    {
        "label": "Switzerland",
        "country_code": "+41",
        "code": "CH"
    },
    {
        "label": "Syrian Arab Republic",
        "country_code": "+963",
        "code": "SY"
    },
    {
        "label": "Taiwan, Province of China",
        "country_code": "+886",
        "code": "TW"
    },
    {
        "label": "Tajikistan",
        "country_code": "+992",
        "code": "TJ"
    },
    {
        "label": "Tanzania, United Republic of",
        "country_code": "+255",
        "code": "TZ"
    },
    {
        "label": "Thailand",
        "country_code": "+66",
        "code": "TH"
    },
    {
        "label": "Timor-Leste",
        "country_code": "+670",
        "code": "TL"
    },
    {
        "label": "Togo",
        "country_code": "+228",
        "code": "TG"
    },
    {
        "label": "Tokelau",
        "country_code": "+690",
        "code": "TK"
    },
    {
        "label": "Tonga",
        "country_code": "+676",
        "code": "TO"
    },
    {
        "label": "Trinidad and Tobago",
        "country_code": "+1868",
        "code": "TT"
    },
    {
        "label": "Tunisia",
        "country_code": "+216",
        "code": "TN"
    },
    {
        "label": "Turkey",
        "country_code": "+90",
        "code": "TR"
    },
    {
        "label": "Turkmenistan",
        "country_code": "+993",
        "code": "TM"
    },
    {
        "label": "Turks and Caicos Islands",
        "country_code": "+1649",
        "code": "TC"
    },
    {
        "label": "Tuvalu",
        "country_code": "+688",
        "code": "TV"
    },
    {
        "label": "Uganda",
        "country_code": "+256",
        "code": "UG"
    },
    {
        "label": "Ukraine",
        "country_code": "+380",
        "code": "UA"
    },
    {
        "label": "United Arab Emirates",
        "country_code": "+971",
        "code": "AE"
    },
    {
        "label": "United Kingdom",
        "country_code": "+44",
        "code": "GB"
    },
    {
        "label": "United States",
        "country_code": "+1",
        "code": "US"
    },
    {
        "label": "United States Minor Outlying Islands",
        "country_code": "+1",
        "code": "UM"
    },
    {
        "label": "Uruguay",
        "country_code": "+598",
        "code": "UY"
    },
    {
        "label": "Uzbekistan",
        "country_code": "+998",
        "code": "UZ"
    },
    {
        "label": "Vanuatu",
        "country_code": "+678",
        "code": "VU"
    },
    {
        "label": "Venezuela, Bolivarian Republic of Venezuela",
        "country_code": "+58",
        "code": "VE"
    },
    {
        "label": "Vietnam",
        "country_code": "+84",
        "code": "VN"
    },
    {
        "label": "Virgin Islands, British",
        "country_code": "+1284",
        "code": "VG"
    },
    {
        "label": "Virgin Islands, U.S.",
        "country_code": "+1340",
        "code": "VI"
    },
    {
        "label": "Wallis and Futuna",
        "country_code": "+681",
        "code": "WF"
    },
    {
        "label": "Western Sahara",
        "country_code": "+212",
        "code": "EH"
    },
    {
        "label": "Yemen",
        "country_code": "+967",
        "code": "YE"
    },
    {
        "label": "Zambia",
        "country_code": "+260",
        "code": "ZM"
    },
    {
        "label": "Zimbabwe",
        "country_code": "+263",
        "code": "ZW"
    }
]
